import React from 'react';
import filterIcon from "../assets/filter-icon.png";

const FilterButton = ({t,isFiltersOpen}) => {
    return (
        <>
            <img
                src={filterIcon}
                alt="Filter"
                className={`filter-icon ${isFiltersOpen ? "" : "rotate180"}`}
            />
            <p>{t("filter")}</p>
        </>
    );
};

export default FilterButton;
